<script>
  import db from '../../db';
  import Message from '../Message.svelte'
  import Map from '../Map.svelte'
  import Confirm from '../Confirm.svelte'

  export let maps;

  const defaultConfirmation = "Are you sure you want to remove this map? All scores will also be deleted!";

  let showCancelDialog = false;
  let confirmData = null;
  let confirmDesc = defaultConfirmation;
  let confirmBtn = "Confirm";

  let confirmLoaderText = null;

  function onShowRemoveConfirm(map) {
    confirmData = map;
    confirmDesc = defaultConfirmation
    confirmBtn = "Confirm"
    showCancelDialog = true;
  }

  async function onRemove(event) {
    try {
      confirmLoaderText = "Removing map...";

      const { error } = await db
        .from('project_maps')
        .delete()
        .eq('map_id', event.detail.map_id)

      if (error) throw 'DB Error';

      showCancelDialog = false;
    } catch {
      confirmDesc = "Error has occured. Hit Retry to try again";
      confirmBtn = "Retry";
    } finally {
      confirmLoaderText = null;
    }
  }
</script>

{#if maps && maps.length}
  <section class="maps">
    {#each maps as map}
      <Map {map}>
        <div slot="footer">
          <button class="nes-btn is-error" on:click={() => onShowRemoveConfirm(map)}>Remove</button>
        </div>
      </Map>
    {/each}
  </section>

  <Confirm title="Warning" desc={confirmDesc} loaderText={confirmLoaderText}
           bind:show={showCancelDialog} data={confirmData} confirmBtn={confirmBtn}
           on:confirm={event => onRemove(event)} on:cancel={() => showCancelDialog = false}
  />
{:else}
  <section class="message-list">
    <Message>
      It looks like there are no maps in this project yet.
    </Message>
  </section>
{/if}

<style>
    .maps {
        color: #222;
        background-color: #aaa;
        padding: .5rem;
        margin-bottom: 2rem;
    }
</style>